import type { Preferences } from "../persistence/GameSave";

const TRACKS = [
  "/music/mickeyscat-moment-of-peace-mickeyscat-554494.mp3",
];

export class MusicManager {
  private audio: HTMLAudioElement;
  private ready = false;
  private waitingForGesture = false;

  constructor() {
    this.audio = new Audio(TRACKS[0]);
    this.audio.loop = true;
    this.audio.volume = 0;
    this.audio.addEventListener("canplaythrough", () => { this.ready = true; }, { once: true });
  }

  start(preferences: Preferences): void {
    this.setVolume(preferences);
    if (preferences.muted || TRACKS.length === 0) return;
    if (this.ready) {
      this.tryResume();
    } else {
      this.audio.addEventListener("canplaythrough", () => this.tryResume(), { once: true });
    }
  }

  update(preferences: Preferences): void {
    this.setVolume(preferences);
    if (preferences.muted || TRACKS.length === 0) {
      this.audio.pause();
      this.waitingForGesture = false;
      return;
    }
    if (this.ready && this.audio.paused) this.tryResume();
  }

  private tryResume(): void {
    void this.audio.play().then(
      () => { this.waitingForGesture = false; },
      () => { this.waitForGesture(); },
    );
  }

  private waitForGesture(): void {
    if (this.waitingForGesture) return;
    this.waitingForGesture = true;
    const resume = (): void => {
      if (!this.audio.paused) {
        this.waitingForGesture = false;
        window.removeEventListener("pointerdown", resume);
        window.removeEventListener("keydown", resume);
        return;
      }
      void this.audio.play().then(
        () => {
          this.waitingForGesture = false;
          window.removeEventListener("pointerdown", resume);
          window.removeEventListener("keydown", resume);
        },
        () => {},
      );
    };
    window.addEventListener("pointerdown", resume);
    window.addEventListener("keydown", resume);
  }

  private setVolume(preferences: Preferences): void {
    this.audio.muted = preferences.muted;
    this.audio.volume = preferences.muted ? 0 : preferences.musicVolume;
  }
}
